module.exports = __webpack_public_path__ + "static/offices-content-image-square-two-4f3d6e30c22607985c5a182c7e4be898.jpg";